import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { LockService } from './lock.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'oc-locked',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormlyBootstrapModule, FormlyModule, RouterModule],
  template: `
    <div class="oc-locked">
      <div>
        <h1 class="mb-4">Locked</h1>
        <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
          <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-light mt-3 mb-4">
              <span *ngIf="saving" class="spinner-border spinner-border-sm"></span>
              <span *ngIf="!saving">Unlock</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  `,
  styles: `
    .oc-locked {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #222;
      width: 100%;
      height: 100vh;
    }

    h1 {
      color: #eee;
    }

    ::ng-deep label {
      color: #eee !important;
    }
  `,
})
export class LockedComponent {
  private lockService = inject(LockService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private toastr = inject(ToastrService);
  private redirectUrl: string | null = null;

  constructor() {
    this.redirectUrl = this.route.snapshot.queryParams['redirectUrl'];
    if (this.lockService.locked === false) {
      this.router.navigate(['/']);
    }
  }

  saving = false;
  options: FormlyFormOptions = {
    formState: {
      submitted: false,
    },
  };

  form = new FormGroup({});
  model = { code: '' };

  fields: FormlyFieldConfig[] = [
    {
      key: 'code',
      type: 'input',
      props: {
        label: 'PIN Code',
        required: true,
      },
    },
  ];

  onSubmit(model: any) {
    if (this.lockService.pin === model.code) {
      const url = this.redirectUrl ?? '/';

      this.lockService.pin = null;
      this.lockService.locked = false;
      this.router.navigate([url]);
    } else {
      this.toastr.error('Incorrect PIN');
    }
  }
}
